import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MobileHeader.css';
import { db } from '../firebaseConfig';
import { collection, onSnapshot } from 'firebase/firestore';
import { FaHome, FaBars, FaTimes, FaRegNewspaper } from 'react-icons/fa';

const MobileHeader = () => {
  const [menuList, setMenuList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "categories"),
      (snapshot) => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setMenuList(data.sort((a, b) => (a.order || 0) - (b.order || 0)));
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <>
      {/* HEADER (NOT STICKY) */}
      <div className="mobile-top-header">
        <Link to="/" className="mobile-logo">
       <img 
      src="/logoo.png" // আপনার লোগো ফাইলটি public ফোল্ডারে থাকলে এভাবে লিখুন
      alt="Vawaiya Express" 
      style={{ height: '40px', width: '90%' }} // প্রয়োজনমতো সাইজ সেট করুন
    />
        </Link>

        <div className="mobile-header-right">
          <Link to="/" className="epaper-btn">
            <FaRegNewspaper />
            <span>ই-পেপার</span>
          </Link>

          <button className="menu-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* CATEGORY (ONLY STICKY PART) */}
      <div className="mobile-category-row">
        <Link to="/" className="mobile-category-link">
          <FaHome />
        </Link>

        <Link to="/" className="mobile-category-link">
          সর্বশেষ
        </Link>

        {menuList.map(menu => (
          <Link
            key={menu.id}
            to={`/category/${menu.name}`}
            className="mobile-category-link"
          >
            {menu.name}
          </Link>
        ))}
      </div>

    {/* DRAWER */}
      <div className={`mobile-drawer ${isOpen ? 'show' : ''}`}>
        <div className="drawer-title">সব বিভাগ</div>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '10px',
          padding: '15px'
        }}>
          {menuList.map(menu => (
            <Link
              key={menu.id}
              to={`/category/${menu.name}`}
              className="drawer-link"
              onClick={() => setIsOpen(false)}
              style={{
                padding: '10px',
                background: '#f4f4f4',
                textAlign: 'center',
                textDecoration: 'none',
                color: '#333',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            >
              {menu.name}
            </Link>
          ))}
        </div>
      </div>

      {isOpen && (
        <div className="drawer-overlay" onClick={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default MobileHeader;